/* eslint-disable */
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect } from 'react';
import {
  Box,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
// import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
/* CSS */
import useStyles from '../../Main.style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useForms from '../../../../hooks/useForms';
import usePractice from '../../../../hooks/usePractice';
const QuarterlyMeetingObjectives = (props) => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  const theme = useTheme();
  const [openFilter, setOpenFilter] = React.useState(false);
  const [quarterlyMeetingForms, setQuarterlyMeetingForms] = useState([]);
  const { getQuarterlyMeetingObjectives } = useForms();
  const { getUserDetailsByEmail, getCountry } = usePractice();
  const [expandedGoal, setExpandedGoal] = React.useState(false);
  const [expandedFP, setExpandedFP] = React.useState(false);
  const [expandedHP, setExpandedHP] = React.useState(false);
  const [expandedMP, setExpandedMP] = React.useState(false);
  const [expandedOP, setExpandedOP] = React.useState(false);
  const [companyGoals, setCompanyGoals] = React.useState([]);
  const [finPriorities, setFinPriorities] = React.useState([]);
  const [humanCapPriorities, setHumanCapPriorities] = React.useState([]);
  const [marketingPriorities, setMarketingPriorities] = React.useState([]);
  const [operationsPriorities, setOperationsPriorities] = React.useState([]);
  const [countryList, setCountryList] = React.useState([]);

  let quarterlyMeetingsArr = [];
  const handleGoalChange = (panel) => (event, expandedGoal) => {
    setExpandedGoal(expandedGoal ? panel : false);
  };

  const handleFPChange = (panel) => (event, expandedFP) => {
    setExpandedFP(expandedFP ? panel : false);
  };

  const handleHPChange = (panel) => (event, expandedHP) => {
    setExpandedHP(expandedHP ? panel : false);
  };

  const handleMPChange = (panel) => (event, expandedMP) => {
    setExpandedMP(expandedMP ? panel : false);
  };

  const handleOPChange = (panel) => (event, expandedOP) => {
    setExpandedOP(expandedOP ? panel : false);
  };

  const loadCompletedForms = async () => {
    const usersListForEmail = await getUserDetailsByEmail({
      emailId: 'enrique.alvarez@vectorgl.com',
    });

    if (usersListForEmail && quarterlyMeetingsArr.length === 0) {
      const quarterlyMeetingObjResult = await getQuarterlyMeetingObjectives({
        userId: usersListForEmail.usersResult[0].id,
      });

      setQuarterlyMeetingForms(quarterlyMeetingObjResult.usersResult);
      quarterlyMeetingsArr = quarterlyMeetingObjResult.usersResult;
      fillReportSections();
    }
  };

  const loadCountries = async () => {
    const countryLists = await getCountry();
    setCountryList(countryLists.usersResult);
    return countryLists.usersResult;
  };

  const separateDataBySection = async (category, country) => {
    // Function to separate data based on category
    if (quarterlyMeetingsArr.length > 0) {
      const filteredData = quarterlyMeetingsArr.filter(
        (obj) => obj?.questionDetails?.sectionDetails?.typeShortName === category,
      );
      return filteredData.sort((a, b) => a?.questionDetails?.rank - b?.questionDetails?.rank);
    }
  };

  const fillReportSections = async () => {
    let countries = (await loadCountries()) || [];
    countries = countries.sort((a, b) => new Date(a['updatedAt']) - new Date(b['updatedAt']));

    if (quarterlyMeetingsArr !== null && quarterlyMeetingsArr.length > 0) {
      let companyGoalsArr = await separateDataBySection('GoalsCompany');
      let finPrioritiesArr = await separateDataBySection('FinancialPrioritiesCompany');
      let humanCapPrioritiesArr = await separateDataBySection('HumanCapitalPrioritiesCompany');
      let marketingPrioritiesArr = await separateDataBySection('MarketingPrioritiesCompany');
      let operationsPrioritiesArr = await separateDataBySection('OperationalPrioritiesbyCountry');

      containsBlankText(companyGoalsArr, 'answer');
      containsBlankText(finPrioritiesArr, 'answer');
      containsBlankText(humanCapPrioritiesArr, 'answer');
      containsBlankText(marketingPrioritiesArr, 'answer');
      containsBlankText(operationsPrioritiesArr, 'answer');

      setCompanyGoals(companyGoalsArr);
      setFinPriorities(finPrioritiesArr);
      setHumanCapPriorities(humanCapPrioritiesArr);
      setMarketingPriorities(marketingPrioritiesArr);

      if (operationsPrioritiesArr) {
        let countryOrder = {};
        countries.map((c, i) => {
          countryOrder[c.countryTitle.toLowerCase()] = i + 1;
        });

        const country = loggedInUserData?.country?.countryTitle;
        const blockNumber = countryOrder[country.toLowerCase()];
        const chunkSize = 3;
        const operationsPrioritiesCountry = selectElements(
          operationsPrioritiesArr,
          loggedInUserData?.countryId,
          chunkSize,
        );
        operationsPrioritiesCountry && setOperationsPriorities(operationsPrioritiesCountry);
      }
    }
  };

  // const selectElements = (array, blockNumber, chunkSize) => {
  //   console.log(array, blockNumber, chunkSize, 6000);
  //   const startIndex = (blockNumber - 1) * chunkSize;
  //   const endIndex = startIndex + chunkSize;
  //   const chunk = array.slice(startIndex, endIndex);

  //   return chunk;
  // };

  const selectElements = (array, countryId, chunkSize) => {
    const chunk = array.filter((elem) => {
      console.log(elem?.questionDetails?.countryId, '==', countryId);
      if (elem?.questionDetails?.countryId == countryId) {
        return elem;
      }
    });
    console.log(chunk, 7000);
    return chunk;
  };
  const containsBlankText = (array, property) => {
    let isBlank = true;

    for (let i = 0; i < array.length; i++) {
      if (array[i][property] !== '') {
        isBlank = false;
        break;
      }
    }

    if (array.length > 0) {
      array[0].isBlank = isBlank;
    }

    // return isBlank;
  };

  useEffect(() => {
    loadCompletedForms();
    fillReportSections();
  }, []);

  useEffect(() => {
    loadCountries();
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  return (
    <>
      <If condition={quarterlyMeetingForms}>
        {' '}
        <Grid container spacing={4} className={classes.QuarterlyMeetingObjectives}>
          <Grid item xs={12} className={classes.innercontent}>
            <Grid container style={{ height: '100%' }}>
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="h5">Quarterly Meeting Objectives</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                      <div>
                        <Typography variant="h4">Company Goals</Typography>
                        <If condition={companyGoals[0]?.isBlank}>
                          No quarterly goals at the moment.
                        </If>
                        <If condition={!companyGoals[0]?.isBlank}>
                          {' '}
                          <Accordion
                            expanded={expandedGoal === 'panel1'}
                            onChange={handleGoalChange('panel1')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {/* Goal 1 */}

                                {companyGoals[0]?.answer || 'No quarterly goal at the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <If condition={!companyGoals[0]?.isBlank}>
                                {' '}
                                <Grid container spacing={2}>
                                  {/* <Grid item xs={12}>
                                <Typography variant="h5" noWrap className={classes.QMODetails}>
                                  {companyGoals[0]?.questionDetails?.text}
                                </Typography>
                              </Grid> */}
                                  {/* <Grid item xs={12}>
                                <Typography variant="body2">{companyGoals[0]?.answer}</Typography>
                              </Grid> */}

                                  {/* <Grid item xs={12}>
                                <Typography variant="h5" noWrap className={classes.QMODetails}>
                                  {companyGoals[1]?.questionDetails?.text}
                                </Typography>
                              </Grid> */}
                                  <Grid item xs={12}>
                                    <Typography variant="body2">
                                      {companyGoals[1]?.answer ||
                                        'No high level objective at the moment.'}
                                    </Typography>
                                  </Grid>

                                  {/* <Grid item xs={12}>
                                <Typography variant="h5" noWrap className={classes.QMODetails}>
                                  {companyGoals[2]?.questionDetails?.text}
                                </Typography>
                              </Grid> */}
                                  <Grid item xs={12}>
                                    <Typography variant="body2">
                                      {companyGoals[2]?.answer || 'No result at the moment.'}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </If>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedGoal === 'panel2'}
                            onChange={handleGoalChange('panel2')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {/* Goal 2 */}
                                {companyGoals[3]?.answer || 'No quarterly goal at the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {companyGoals[4]?.answer ||
                                      'No high level objective at the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {companyGoals[5]?.answer || 'No result at the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedGoal === 'panel3'}
                            onChange={handleGoalChange('panel3')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {companyGoals[6]?.answer || 'No quarterly goal at the moment.'}
                                {/* Goal 3 */}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {companyGoals[7]?.answer ||
                                      'No high level objective at the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {companyGoals[8]?.answer || 'No result at the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        </If>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                      <div>
                        <Typography variant="h4">Financial Priorities</Typography>
                        <If condition={finPriorities[0]?.isBlank}>
                          No quarterly Financial priorities at the moment.
                        </If>
                        <If condition={!finPriorities[0]?.isBlank}>
                          <Accordion
                            expanded={expandedFP === 'panel1'}
                            onChange={handleFPChange('panel1')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {finPriorities[0]?.answer ||
                                  'No quarterly financial priority at the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {finPriorities[1]?.answer}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {finPriorities[2]?.answer}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedFP === 'panel2'}
                            onChange={handleFPChange('panel2')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                <Typography variant="h5">
                                  {finPriorities[3]?.answer ||
                                    'No quarterly financial priority at the moment.'}
                                </Typography>
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {finPriorities[4]?.answer ||
                                      'No quarterly financial action item at the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {finPriorities[5]?.answer ||
                                      'No quarterly financial result at the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedFP === 'panel3'}
                            onChange={handleFPChange('panel3')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {finPriorities[6]?.answer ||
                                  'No quarterly financial priority at the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {finPriorities[7]?.answer ||
                                      'No quarterly financial action item at the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {finPriorities[8]?.answer ||
                                      'No quarterly financial result at the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        </If>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                      <div>
                        <Typography variant="h4">Human Capital Priorities</Typography>
                        <If condition={humanCapPriorities[0]?.isBlank}>
                          No quarterly priorities for Human Capital at the moment.
                        </If>
                        <If condition={!humanCapPriorities[0]?.isBlank}>
                          <Accordion
                            expanded={expandedHP === 'panel1'}
                            onChange={handleHPChange('panel1')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {humanCapPriorities[0]?.answer ||
                                  'No quarterly human capital priority description the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {humanCapPriorities[1]?.answer ||
                                      'No quarterly human capital action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {humanCapPriorities[2]?.answer ||
                                      'No quarterly human capital result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedHP === 'panel2'}
                            onChange={handleHPChange('panel2')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {humanCapPriorities[3]?.answer ||
                                  'No quarterly human capital priority description the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {humanCapPriorities[4]?.answer ||
                                      'No quarterly human capital action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {humanCapPriorities[5]?.answer ||
                                      'No quarterly human capital result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedHP === 'panel3'}
                            onChange={handleHPChange('panel3')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {' '}
                                {humanCapPriorities[6]?.answer ||
                                  'No quarterly human capital priority description the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {humanCapPriorities[7]?.answer ||
                                      'No quarterly human capital action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {humanCapPriorities[8]?.answer ||
                                      'No quarterly human capital result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        </If>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6}>
                    <Box className={classes.innercontentWhite} style={{ height: '100%' }}>
                      <div>
                        <Typography variant="h4">Marketing Priorities</Typography>
                        <If condition={marketingPriorities[0]?.isBlank}>
                          No quarterly Marketing priorities at the moment.
                        </If>
                        <If condition={!marketingPriorities[0]?.isBlank}>
                          <Accordion
                            expanded={expandedMP === 'panel1'}
                            onChange={handleMPChange('panel1')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {marketingPriorities[0]?.answer ||
                                  'No quarterly marketing priority description the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {marketingPriorities[1]?.answer ||
                                      'No quarterly marketing priority action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {marketingPriorities[2]?.answer ||
                                      'No quarterly marketing priority result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedMP === 'panel2'}
                            onChange={handleMPChange('panel2')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {marketingPriorities[3]?.answer ||
                                  'No quarterly marketing priority description the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {marketingPriorities[4]?.answer ||
                                      'No quarterly marketing priority action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {marketingPriorities[5]?.answer ||
                                      'No quarterly marketing priority result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                          <Accordion
                            expanded={expandedMP === 'panel3'}
                            onChange={handleMPChange('panel3')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {marketingPriorities[6]?.answer ||
                                  'No quarterly marketing priority description the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {marketingPriorities[7]?.answer ||
                                      'No quarterly marketing priority action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {marketingPriorities[8]?.answer ||
                                      'No quarterly marketing priority result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        </If>
                      </div>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <Box className={classes.innercontentWhite}>
                      <div>
                        <Typography variant="h4">
                          My Country&rsquo;s Operational Objectives -
                          {loggedInUserData?.country?.countryTitle == 'USA'
                            ? 'United States'
                            : loggedInUserData?.country?.countryTitle}
                        </Typography>
                        operationsPriorities
                        {console.log(operationsPriorities, 4000)}
                        <If condition={[0]?.isBlank}>
                          No quarterly operational priorities at the moment.
                        </If>
                        <If condition={!operationsPriorities[0]?.isBlank}>
                          {' '}
                          <Accordion
                            expanded={expandedOP === 'panel1'}
                            onChange={handleOPChange('panel1')}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel4bh-content"
                              id="panel4bh-header"
                            >
                              <Typography variant="h5">
                                {operationsPriorities[0]?.answer ||
                                  'No quarterly operational at the moment.'}
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid container spacing={2}>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {operationsPriorities[1]?.answer ||
                                      'No quarterly operational action item the moment.'}
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography variant="body2">
                                    {operationsPriorities[2]?.answer ||
                                      'No quarterly operational result the moment.'}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        </If>
                      </div>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}></Grid>
        </Grid>
      </If>
      <If condition={!quarterlyMeetingForms}>
        There is no approved Quarterly Meeting Objectives yet for current quarter.
      </If>
    </>
  );
};

export default QuarterlyMeetingObjectives;
